export const fstpData = [

  {
    id: 1,
    basicInfo: {
      name: "Sakhipur Faecal Sludge Treatment Plant",
      shortName: "#NAME?",
      administrativeDivision: "Sakhipur Municipality",
      areaName: "Selami Chala, Gargobindpur mouza, 06 no ward, Sakhipur Municipality",
      location: {
        coordinates: "24.30944, 90.154272",
        x: "24.30944",
        y: "90.154272"
      },
      installationYear: "2015",
      organization: "Water Aid",
      organizationLogo: "/wateraid.png",
      projectName: "Water Aid",
      status: "Operating"
    },
    capacity: {
      designedTreatmentCapacity: "328 m3/day",
      actualTreatmentCapacity: "167 m3/day",
      designedEnergyRequirementsActualUsage: "minimum 200 kw"
    },
    containmentSystem: {
      septicTank: "9%",
      singlePit: "91%"
    },
    sludgeCharacteristics: {
      totalSolids: null,
      fecalColiform: "27000 CFU/100mL",
      BOD: "50 mg/L",
      NO3: "134.35 mg/L",
      PO4: "25.40 mg/L",
      TSS: "51 mg/L"
    },
    effluentStandard: {
      fecalColiform: "600 CFU/100mL",
      BOD: "5.2 mg/L",
      NO3: "9.4 mg/L",
      PO4: "1.48 mg/L",
      TSS: "10 mg/L"
    },
    plantDetails: {
      footprint: "0.0157 ha",
      collectionUnit: "No of Vacuum tanker- 01, capacity 1000L/ other",
      emptyingFee: "1000 BDT per 1000 Litter/ 01 trip",
      tippingFee: "Tripping fee at FSTP 01 BDT per m³"
    },
    costInfo: {
      capEx: "1.25 core (Approximate)",
      opEx: "15,96966 BDT per year",
      landCost: "25,00,000 BDT"
    },
    design: {
      criteria: null,
      wastewaterTreatment: null
    },
    endUser: {
      served: "Households (primary)/Others"
    }
  },
  {
    id: 2,
    basicInfo: {
      name: "Saidpur Faecal Sludge Treatment Plant",
      shortName: "#NAME?",
      administrativeDivision: "Saidpur Municipality",
      areaName: "Shurkimoholla, Vagar, Ward No: 11 Saidpur, Nilphamari",
      location: {
        coordinates: "25.772193, 88.888247",
        x: "25.772193",
        y: "88.888247"
      },
      installationYear: "2018",
      organization: "Water Aid",
      organizationLogo: null,
      projectName: "Water Aid",
      organizationLogo: "/wateraid.png",
      status: "Operating"
    },
    capacity: {
      designedTreatmentCapacity: "26 m3/day",
      actualTreatmentCapacity: "12 m3/day",
      designedEnergyRequirementsActualUsage: "Minimum: 40.0 Kw"
    },
    containmentSystem: {
      septicTank: "43.5%",
      singlePit: "38.2%",
      doublePit: "11.5%",
      others: "6.8%"
    },
    sludgeCharacteristics: {
      fecalColiform: "7800 CFU/100ml",
      BOD: "416 mg/L",
      NO3: "589.82 mg/L",
      PO4: "33.4 mg/L",
      TSS: "33.0 mg/L"
    },
    effluentStandard: {
      fecalColiform: "200 CFU/100ml",
      BOD: "23 mg/L",
      NO3: "42.17 mg/L",
      PO4: "4 mg/L",
      TSS: "12 mg/L"
    },
    plantDetails: {
      footprint: "0.688 ha",
      collectionUnit: "No of 04 Vacuum tanker 500 liters, 1000 liters, 2000 liters, 3500 liters",
      emptyingFee: "1000 liters: 800.00 BDT, 3500 liters: 2500.00 BDT",
      tippingFee: "800.00 BDT"
    },
    costInfo: {
      capEx: "7.0 core",
      opEx: "26,13,800.00 BDT",
      landCost: "25,500,000.00 BDT"
    },
    design: {
      criteria:
      {
        landArea: "1.70",
        dryingBed: {
          unplanted: {
            count: 20,
            size: {
              length: "5.40m",
              width: "2.64m",
              depth: "0.15m"
            }
          },
          planted: {
            count: 4,
            size: {
              length: "10.06m",
              width: "7.32m",
              depth: "0.46m"
            }
          }
        }
      },
      wastewaterTreatment:
        "Biological treatment through constructed wetland, pre-polishing and polishing pond"
    },
    endUser: {
      served: "Households (primary)/Others"
    }
  },
  {
    id: 3,
    basicInfo: {
      name: "Lakshmipur Faecal Sludge Treatment Plant",
      shortName: "#NAME?",
      administrativeDivision: "Lakshmipur Municipality",
      areaName: "Kacharibag",
      location: {
        coordinates: "22.93501, 90.807822",
        x: "22.93501",
        y: "90.807822"
      },
      installationYear: "2013",
      organization: "DPHE",
      organizationLogo: null,
      projectName: "DPHE",
      organizationLogo: "/dphe_logo.png",
      status: "Operating"
    },
    capacity: {
      designedTreatmentCapacity: null,
      actualTreatmentCapacity: "10 m3/day.8",
      designedEnergyRequirementsActualUsage: null
    },
    containmentSystem: null,
    sludgeCharacteristics: {
      totalSolids: null,
      BOD: "5,000 mg/L",
      COD: "28,100 mg/L",
      TSS: "59,036 mg/L"
    },
    effluentStandard: {
      totalSolids: null,
      BOD: "12.5 mg/L",
      COD: "148 mg/L",
      TSS: "57 mg/L"
    },
    plantDetails: {
      footprint: "0.39 Ac",
      collectionUnit: "03 active vaccum tankers ( 1,500 L)",
      emptyingFee: "Residential= BDT 1.00/Liter Institution= BDT 1.20/Liter For Low Income Community= BDT 0.60/Liter",
      tippingFee: null
    },
    costInfo: {
      capEx: null,
      opEx: null,
      landCost: null
    },
    design: {
      criteria:
      {
        landArea: "Planted Drying Bed / Reed beds",
        dryingBed: {
          planted: {
            count: 2,
            size: {
              length: "12m",
              width: "12m",
            }
          }
        }
      },
      wastewaterTreatment: "Planted Drying bed/ Reed beds, Polishing pond"
    },
    endUser: {
      served: null
    }
  },
  {
    id: 4,
    basicInfo: {
      name: "Faridpur Faecal Sludge Treatment Plant",
      shortName: "#NAME?",
      administrativeDivision: "Faridpur Municipality",
      areaName: "Adompur",
      location: {
        coordinates: "23.622673, 89.845568",
        x: "23.622673",
        y: "89.845568"
      },
      installationYear: "2016",
      organization: "Practical Action",
      organizationLogo: "/Practical-Action.png",

      projectName: "25 Town AIIB Project, DPHE",
      status: "Operating"
    },
    capacity: {
      designedTreatmentCapacity: "24 m3/day",
      actualTreatmentCapacity: "24 m3/day",
      designedEnergyRequirementsActualUsage: null
    },
    containmentSystem: {
      septicTank: "59%",
      pitLatrine: "40%",
      others: "1%"
    },
    sludgeCharacteristics: null,
    effluentStandard: null,
    plantDetails: {
      footprint: "0.607 ha",
      collectionUnit: "06 vaccum tankers",
      emptyingFee: "1000 ~ 1200 tk/ per trip, For LIC- 700 tk/trip",
      tippingFee: null
    },
    costInfo: {
      capEx: null,
      opEx: "200,000 BDT/year",
      landCost: "Land is leased by SDC"
    },
    design: {
      criteria:
      {
        landArea: "Drying Bed",
        dryingBed: {
          unplanted: {
            count: 16,
            size: {
              length: "10.72m",
              width: "3.75m"
            }
          },
          planted: {
            count: 12,
            size: {
              length: "8m",
              width: "8m"
            }
          }
        }
      },
      wastewaterTreatment:
        "Treatment method= Combined treatmentmethod (Nitrification, de-nitrification,filtrationaeration)"
    },
    endUser: {
      served: "others"
    }
  },
  {
    id: 5,
    basicInfo: {
      name: "Chattogram Faecal Sludge Treatment Plant",
      shortName: "#NAME?",
      administrativeDivision: "Chattogram City Corporation",
      areaName: "Arefin Nagar",
      location: {
        coordinates: "22.386945, 91.797595",
        x: "22.386945",
        y: "91.797595"
      },
      installationYear: "2019",
      organization: "WSUP",
      organizationLogo: "/wsup.png",
      projectName: "WSUP",

      status: "Operating"
    },
    capacity: {
      designedTreatmentCapacity: "33 m3/day",
      actualTreatmentCapacity: "21 m3/day",
      designedEnergyRequirementsActualUsage: null
    },
    containmentSystem: null,
    sludgeCharacteristics: null,
    effluentStandard: null,
    plantDetails: {
      footprint: "0.65 Ac",
      energyRequirement: null,
      collectionUnit: "05 active vaccum tankers ( 1,500 L,2,000 Land 4,000 L)",
      emptyingFee: "Residential= BDT 1.00/Liter Institution= BDT 2.00/Liter For Low Income Community= BDT 0.60/Liter",
      tippingFee: null
    },
    costInfo: {
      capEx: null,
      opEx: null,
      landCost: null
    },
    design: {
      criteria:
      {
        landArea: "Unplanted Drying Bed followed by Settler, ABR and Polishing Pond",
        dryingBed: {
          unplanted: {
            count: 21,
            capacityPerBed: "12 m³"
          }
        },
        treatmentUnits: {
          ABR: {
            chamberCount: 13
          },
        }
      },
      wastewaterTreatment:
        "Unplanted Drying bed → Settler → ABR → Polishing pond"
    },
    endUser: {
      served: null
    }
  },
  {
    id: 6,
    basicInfo: {
      name: "Kushtia Faecal Sludge Treatment Plant",
      shortName: "#NAME?",
      administrativeDivision: "Kushtia Municipality",
      areaName: "Kanabill road, Kushtia",
      location: {
        coordinates: "23.91242, 89.09473",
        x: "23.91242",
        y: "89.09473"
      },
      installationYear: "2012",
      organization: "SNV",
      organizationLogo: "/snv.png",
      projectName: "SNV",
      status: "Operating"
    },
    capacity: {
      designedTreatmentCapacity: "18 m3/day",
      actualTreatmentCapacity: "10 m3/day",
      designedEnergyRequirementsActualUsage: "3kwh/day"
    },
    containmentSystem: {
      septicTank: "50%",
      singlePit: "45%",
      doublePit: null,
      others: "5%"
    },
    sludgeCharacteristics: {
      totalSolids: "30kg/m3 (Average)",
      BOD: "844 mg/L",
      COD: null,
      TSS: "29052 mg/L"
    },
    effluentStandard: {
      totalSolids: null,
      BOD: "48 mg/L",
      COD: null,
      TSS: "135 mg/L"
    },
    plantDetails: {
      footprint: "2400 m2",
      collectionUnit: "5 Vacutugs,1-1m3, 2-1.5m3, 1-2m3, 1-4m3",
      emptyingFee: "1st trip: 1m3-1000tk, 1.5m3-1500tk, 4m3-2000tk, Pit-800tk Every next trip: 1m3-500tk, 1.5m3-600tk,4m3-1000tk, Pit-400tk",
      tippingFee: null
    },
    costInfo: {
      capEx: "5000000BDT",
      opEx: "180000BDT",
      landCost: null
    },
    design: {
      criteria: {
        landArea: "Drying Bed",
        dryingBed: {
          unplanted: {
            count: 4,
            size: {
              length: "10m",
              width: "6m"
            }
          }
        }
      },
      wastewaterTreatment: "Cocopeat filter-------→ Polishing Pond"
    },
    endUser: {
      served: "Households /Institutions/Commercial"
    }
  },

  {
    id: 7,
    basicInfo: {
      name: "Jhenaidah Faecal Sludge Treatment Plant",
      shortName: "#NAME?",
      administrativeDivision: "Jhenaidah Municipality",
      areaName: "Mohishbathan, Jhenaidah",
      location: {
        coordinates: "23.549375, 89.121293",
        x: "23.549375",
        y: "89.121293"
      },
      installationYear: "2012",
      organization: "SNV",
      organizationLogo: "/snv.png",
      projectName: "SNV",
      status: "Operating"
    },
    capacity: {
      designedTreatmentCapacity: "36 m3/day",
      actualTreatmentCapacity: "12 m3/day",
      designedEnergyRequirementsActualUsage: "No energy needed"
    },
    containmentSystem: {
      septicTank: "46%",
      singlePit: "49%",
      doublePit: null,
      others: "5%"
    },
    sludgeCharacteristics: {
      totalSolids: "30kg/m3 (Average)",
      BOD: "895 mg/l",
      COD: null,
      TSS: "28356 mg/l"
    },
    effluentStandard: {
      totalSolids: null,
      BOD: "32.5 mg/L",
      COD: null,
      TSS: "135 mg/L"
    },
    plantDetails: {
      footprint: "1400 m2",
      collectionUnit: "2 Vacutugs,1-1m3, 1-2m3",
      emptyingFee: "Residential (non-slum)-1000BDT/m3,Residential (slum)-500BDT/m3, Non-residential (Commercial, institution)-1500BDT/m3",
      tippingFee: null
    },
    costInfo: {
      capEx: "8000000BDT",
      opEx: "120000BDT",
      landCost: null
    },
    design: {
      criteria: {
        landArea: "Planted Drying Bed / Constructed Wetland",
        dryingBed: {
          planted: {
            count: 5,
            size: {
              length: "9.2m",
              width: "5.2m"
            }
          },
          unplanted: {
            count: 3,
            size: {
              length: "3.067m",
              width: "5.2m"
            }
          }
        }
      },
      wastewaterTreatment: "Horizontal Planted filter----→Natural Pond"
    },
    endUser: {
      served: "Households /Institutions/Commercial"
    }
  },

  {
    id: 8,
    basicInfo: {
      name: "Jashore Faecal Sludge Treatment Plant",
      shortName: "#NAME?",
      administrativeDivision: "Jashore Municipality",
      areaName: "Jhumjhumpur, Jashore",
      location: {
        coordinates: "23.161941, 89.239988",
        x: "23.161941",
        y: "89.239988"
      },
      installationYear: "2018",
      organization: "SNV",
      organizationLogo: "./snv.png",
      projectName: "SNV",
      status: "Operating"
    },
    capacity: {
      designedTreatmentCapacity: "9 m3/day",
      actualTreatmentCapacity: "99 m3/day",
      designedEnergyRequirementsActualUsage: "3kwh/day"
    },
    containmentSystem: {
      septicTank: "58.5%",
      singlePit: "6.9%",
      doublePit: "28.62%",
      others: "5.98%"
    },
    sludgeCharacteristics: {
      totalSolids: "30kg/m3 (Average)",
      BOD: "Not tested yet",
      COD: null,
      TSS: "Not tested yet",
    },
    effluentStandard: {
      totalSolids: null,
      BOD: "Not tested yet",
      COD: null,
      TSS: "Not tested yet"
    },
    plantDetails: {
      footprint: "1400 m2",
      collectionUnit: "5 Vacutugs,3-1.5m3, 1-2m3,1-2.5m3",
      emptyingFee: "1st trip-2300BDT (2.5m3), Every next trip-1500BDT",
      tippingFee: null
    },
    costInfo: {
      capEx: "3000000BDT",
      opEx: "180000BDT",
      landCost: null
    },
    design: {
      criteria: {
        landArea: "Unplanted Drying Bed",
        dryingBed: {
          unplanted: {
            count: 3,
            size: {
              length: "10m",
              width: "6m"
            }
          }
        }
      },
      wastewaterTreatment: "Cocopeat filter--------→Polishing Pond"
    },
    endUser: {
      served: "Households /Institutions/Commercial"
    }
  },
  {
    id: 9,
    basicInfo: {
      name: "Benapole Faecal Sludge Treatment Plant",
      shortName: "#NAME?",
      administrativeDivision: "Benapole Municipality",
      areaName: "Kagoj Pukuria, Benapole",
      location: {
        coordinates: "23.048003, 88.929841",
        x: "23.048003",
        y: "88.929841"
      },
      installationYear: "2022",
      organization: "DPHE",
      organizationLogo: "/dphe_logo.png",
      projectName: "SNV/UGIIP-III, DPHE",
      status: "Operating"
    },
    capacity: {
      designedTreatmentCapacity: "30 m3/day",
      actualTreatmentCapacity: "10 m3/day",
      designedEnergyRequirementsActualUsage: "No energy needed"
    },
    containmentSystem: {
      septicTank: "16%",
      singlePit: "60%",
      doublePit: "23 %",
      others: "1%"
    },
    sludgeCharacteristics: {
      totalSolids: "30kg/m3 (Average)",
      BOD: "Not tested yet",
      COD: null,
      TSS: "Not tested yet"
    },
    effluentStandard: {
      totalSolids: null,
      BOD: "Not tested yet",
      COD: null,
      TSS: "Not tested yet"
    },
    plantDetails: {
      footprint: "1575 m2",
      collectionUnit: "1 Vacutugs, 1.5m3",
      emptyingFee: null,
      tippingFee: null
    },
    costInfo: {
      capEx: "20000000BDT",
      opEx: null,
      landCost: null
    },
    design: {
      criteria: {
        landArea: "Planted Drying Bed",
        dryingBed: {
          planted: {
            count: 3,
            size: {
              length: "16.1m",
              width: "9m"
            }
          }
        }
      },
      wastewaterTreatment: "Settler----→ ABR----→AF--------→\nPolishing Pond"
    },
    endUser: {
      served: "Households /Institutions/Commercial"
    }
  },
  {
    id: 10,
    basicInfo: {
      name: "Gazipur Faecal Sludge Treatment Plant",
      shortName: "#NAME?",
      administrativeDivision: "Gazipur City Corporation",
      areaName: "Meghdubi, Gazipur",
      location: {
        coordinates: "23.938573, 90.435892",
        x: "23.938573",
        y: "90.435892"
      },
      installationYear: "2022",
      organization: "SNV",
      organizationLogo: "/snv.png",
      projectName: "SNV",
      status: "Operating"
    },
    capacity: {
      designedTreatmentCapacity: "18 m3/day",
      actualTreatmentCapacity: "18 m3/day",
      designedEnergyRequirementsActualUsage: null
    },
    containmentSystem: {
      septicTank: "50%",
      singlePit: "10.1%",
      doublePit: "2.62 %",
      others: "37.28%"
    },
    sludgeCharacteristics: {
      totalSolids: "30kg/m3",
      BOD: null,
      COD: null,
      TSS: null
    },
    effluentStandard: null,
    plantDetails: {
      footprint: "1800 m2",
      energyRequirement: null,
      collectionUnit: "3 Vacutugs, 2m3",
      emptyingFee: null,
      tippingFee: null
    },
    costInfo: {
      capEx: "70,00,000BDT",
      opEx: null,
      landCost: null
    },
    design: {
      criteria: {
        landArea: "Planted Drying Bed",
        dryingBed: {
          planted: {
            count: 6,
            size: {
              length: "12.5m",
              width: "5m"
            }
          }
        }
      },
      wastewaterTreatment: "ABR---→AF-----→Horizontal Planted Gravel Filter----→Polishing Pond"
    },
    endUser: {
      served: "Households /Institutions/Commercial"
    }
  },
  {
    id: 11,
    basicInfo: {
      name: "Teknaf Faecal Sludge Treatment Plant",
      shortName: "#NAME?",
      administrativeDivision: "Teknaf Municipility",
      areaName: "Meghdubi, Gazipur",
      location: {
        coordinates: "20.8529167,92.3052222",
        x: "20.8529167",
        y: "92.3052222"
      },
      installationYear: "2020",
      organization: "ICRC",
      organizationLogo: "/icrc.svg",
      projectName: "ICRC",
      status: "Operating"
    },
    capacity: {
      designedTreatmentCapacity: "20 m3/day",
      actualTreatmentCapacity: null,
      designedEnergyRequirementsActualUsage: "100 to 120 KW"
    },
    containmentSystem: null,
    sludgeCharacteristics: null,
    effluentStandard: null,
    plantDetails: {
      footprint: "3500 m2",
      energyRequirement: null,
      collectionUnit: "Two Vacu tugs (1,000L and 2,500L)",
      emptyingFee: null,
      tippingFee: null
    },
    costInfo: {
      capEx: null,
      opEx: "11,75,000 BDT",
      landCost: null
    },
    design: {
      criteria: {
        landArea: "35m x 100m",
        dryingBed: {
          total: {
            count: 9,
            size: {
              area: "45m²"
            }
          }
        }
      },
      wastewaterTreatment: "Treatment method= Planted and unplanted drying beds, followed by three stabilization ponds"
    },
    endUser: {
      served: "Households"
    }
  }
];